import { useCallback, useEffect, useRef, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useSelector, useDispatch } from "react-redux";
import { textAlign } from "@mui/system";
import { ProgressBar } from "react-bootstrap";
import OnBoardingSectionBroker from "./Home/OnBoardingSectionBroker";
import CourseCardListBody from "./Course/CourseCardListBody";
import InProgressSection from "./Home/InProgressSection";
import CalendarSection from "./Home/CalendarSection";
import MyDashboardSection from "./Home/MyDashboardSection";
import MyAreaSection from "./Home/MyAreaSection";
import {
  recommendationViewResponse,
  recommendationViewData,
  recommendationViewClear,
} from "../redux/recommendationView/actions";
import _, { parseInt } from "lodash";
import Slider from "react-slick";
import PrevArrow from "./LearningPaths/PrevArrow";
import NextArrow from "./LearningPaths/NextArrow";
import SliderCourseListing from "./LearningPaths/SliderCourseListing";
import RecommendationView from "./RecommendationView";
import MyWall from "./Home/MyWall";
import {
  getLearningPathBroker,
  getModuleListingClear,
  getModuleListingClearBroker,
  getSelectedCatId,
} from "../redux/courses/actions";
import { useNavigate } from "react-router-dom";
import CONFIG from "../utils/config";
import Loader from "./Loader/Loader";
import MainSectionBanner from "./MainSectionBanner";
import { SessionKeys } from "../utils/AppUtils";
import EventsCalendar from "./Calendar/EventsCalendar";
import CalendarMarketingHomeSection from "./Home/CalendarMarketingHomeSection";
import PopularVideoCourse from "./b2cComponents/homepage/PopularVideoCourse";
import BannerSectionB2C from "./b2cComponents/homepage/BannerSectionB2C";
import SubscriptionPricing from "./b2cComponents/homepage/SubscriptionPricing";
import SubscriptionPriceSectionComponent from "./NewDesign/SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import UsefulCourses from "./NewDesign/UsefulEntity/UsefulCourses";
import UsefulVideos from "./NewDesign/UsefulEntity/UsefulVideos";
import CoursesIncludedWithSubscription from "./NewDesign/UsefulEntity/CourseIncludedWithSubscription";
import CoursesWithSubscription from "./NewDesign/UsefulEntity/CoursesWithSubscription";
import MyDashboardSectionManager from "./Home/MyDashboardSectionManager";
import { userDetailBroker } from "../redux/user/actions";
import PodcastAndFBFeedSection from "./PodcastAndFBFeedSection";
import { useTranslation } from "react-i18next";

const MainSection = ({ startJoyRide }) => {
  const observer = useRef();
  const observer2 = useRef();
  const observer3 = useRef();
  const observer4 = useRef();

  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);
  const learningPathBroker = useSelector(
    (state) => state.courses.learningPathBroker
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [isGuest, setIsGuest] = useState(false);

  const [iframePodcast, setIframePodcast] = useState("");
  const [iframeFB, setIframeFB] = useState("");

  const [fetchOBLPData, setFetchOBLPData] = useState(false);
  const [fetchMyAreaData, setFetchMyAreaData] = useState(false);
  const [fetchMyWallData, setFetchMyWallData] = useState(false);
  const [showPodcast, setShowPodcast] = useState(false);

  const paginateOBLP = useCallback((node) => {
    if (fetchOBLPData) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      console.log(entries[0], entries[0].isIntersecting);
      if (entries[0].isIntersecting && !fetchOBLPData) {
        setFetchOBLPData(true);
      }
    });
    if (node) observer.current.observe(node);
  }, []);

  const paginateMyArea = useCallback((node) => {
    if (fetchMyAreaData) return;
    if (observer2.current) observer2.current.disconnect();

    observer2.current = new IntersectionObserver((entries) => {
      console.log(entries[0], entries[0].isIntersecting);
      if (entries[0].isIntersecting && !fetchMyAreaData) {
        setFetchMyAreaData(true);
      }
    });
    if (node) observer2.current.observe(node);
  }, []);

  const paginatePodCast = useCallback((node) => {
    if (showPodcast) return;
    if (observer3.current) observer3.current.disconnect();

    observer3.current = new IntersectionObserver((entries) => {
      console.log(entries[0], entries[0].isIntersecting);
      if (entries[0].isIntersecting && !showPodcast) {
        setShowPodcast(true);
      }
    });
    if (node) observer3.current.observe(node);
  }, []);

  const paginateMyWall = useCallback((node) => {
    if (fetchMyWallData) return;
    if (observer4.current) observer4.current.disconnect();

    observer4.current = new IntersectionObserver((entries) => {
      console.log(entries[0], entries[0].isIntersecting);
      if (entries[0].isIntersecting && !fetchMyWallData) {
        setFetchMyWallData(true);
      }
    });
    if (node) observer4.current.observe(node);
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     userDetailBroker({
  //       module: "getOrderDetailBroker",
  //       apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //     })
  //   );
  // }, []);

  useEffect(() => {
    dispatch(getModuleListingClearBroker());
    dispatch(getModuleListingClear());
    if (!_.isEmpty(authBroker)) {
      if (authBroker?.payload?.user?.broker_id) {
        dispatch(
          getLearningPathBroker({
            module: "getAllLearningPathBroker",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              broker_id: authBroker?.payload?.user?.broker_id,
              is_onboarding: true,
              assigned: 1,
              language: activeLanguage ? activeLanguage : "",
            },
          })
        );
      }
      setIsGuest(authBroker.payload.user.role.includes("guest"));
    }
  }, [dispatch, authBroker, activeLanguage]);

  // useEffect(() => {
  //   if (!_.isEmpty(userDetailRes)) {
  //     if (userDetailRes.status === "success") {
  //       console.log("userDetailRes111111111: ", userDetailRes);

  //       setIframePodcast(userDetailRes?.payload?.payload?.youtube_ifram);
  //       setIframeFB(userDetailRes?.payload?.payload?.facebook_feed);
  //     }
  //     // setIsLoading(false)
  //   }
  // }, [userDetailRes]);

  useEffect(() => {
    console.log("SHOW ONBOARDING", learningPathBroker);
    if (
      !_.isEmpty(learningPathBroker) &&
      learningPathBroker.status === "success"
    ) {
      if (
        _.isArray(learningPathBroker.payload.payload) &&
        learningPathBroker.payload.payload.length > 0
      ) {
        setShowOnboarding(true);
      }
    }
  }, [learningPathBroker]);

  return (
    <>
      {/*MyDashboard and calendar*/}
      {/* <Loader start={isLoading} /> */}
      {authBroker.payload?.user.role.includes("customer") ||
      localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) === "false" ? (
        ""
      ) : (
        <section
          className={
            userRole === "instructor" || userRole === "host"
              ? "dashboard-calendar New-dashboard p-0"
              : "dashboard-calendar New-dashboard pt-5g pb-5 kk"
          }
        >
          <div className="container">
            <div className="row">
              {(userRole === "realtor" || userRole === "manager") && (
                // localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !==
                //   "false" &&
                <div className="col-md-12 calen-section" id="myDashboard">
                  {userRole === "manager" || true ? (
                    <MyDashboardSectionManager
                      auth={auth}
                      setIsLoading={setIsLoading}
                    />
                  ) : localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !==
                    "false" ? (
                    <MyDashboardSection auth={auth} />
                  ) : (
                    ""
                  )}
                </div>
              )}

              {false && (
                <div
                  className={
                    userRole === "instructor" || userRole === "host"
                      ? "col-md-12 calen-section mt-4"
                      : "col-md-12 calen-section mt-4"
                  }
                >
                  <div className="calsec" id="myCalendar">
                    <CalendarSection />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      <div className="linrs"></div>

      <div ref={paginateOBLP} className="calendar-homesection pt-5g pb-5">
        <CalendarMarketingHomeSection />
      </div>

      <div ref={paginateMyArea}>
        {authBroker?.payload?.user?.role.includes("customer") || authBroker?.payload?.user?.access_type ===3 ? (
          ""
        ) : (userRole === "realtor" || userRole === "manager") &&
          showOnboarding ? (
          <>
            {/* <div id="myOnboard" className="center_line mt-3"></div> */}
            {/* <div className="New-dashboard learning">
              <section className="my_onbording pt-5g pb-5g">
                <div className="container">
                  <div className="search_heading mb-4" id="myOnboard-div">
                    <p className="lable-heading_search m-0">{t('myOnboarding')}</p>
                  </div> */}
            <OnBoardingSectionBroker fetchData={fetchOBLPData} />
            {/* </div>
              </section>
            </div> */}
          </>
        ) : (
          ""
        )}
      </div>

      {authBroker.payload?.user.role.includes("customer") || authBroker?.payload?.user?.access_type ===3 ? (
        ""
      ) : userRole === "realtor" || userRole === "manager" ? (
        <div ref={paginatePodCast}>
          {/*<div id="myOnboard" className="center_line m-0"></div>*/}
          <MyAreaSection fetchData={fetchMyAreaData} />
        </div>
      ) : (
        ""
      )}

      {(userRole === "realtor" || userRole === "manager") &&
      (!_.isEmpty(userDetailRes?.payload?.payload?.youtube_ifram) ||
        !_.isEmpty(userDetailRes?.payload?.payload?.facebook_feed) ||
        !_.isEmpty(userDetailRes?.payload?.payload?.linkedin_feed)) ? (
        <div ref={paginateMyWall}>
          {/* {(!_.isEmpty(iframePodcast) || !_.isEmpty(iframeFB)) && <div id="myOnboard" className="center_line m-0"></div>} */}
          <PodcastAndFBFeedSection
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isMobile={false}
          />
        </div>
      ) : (
        ""
      )}

      {true ||
      authBroker.payload?.user.role.includes("customer") ||
      localStorage.getItem(SessionKeys.SHOW_MY_WALL) === "false"
        ? ""
        : (userRole === "realtor" || userRole === "manager") && (
            <>
              {/*<div id="myOnboard" className="center_line m-0"></div>*/}
              <section className="John_section New-dashboard gap-top-bottom pb-5">
                <div className="container">
                  <div className="row">
                    <div className="col-md-4 mt-1">
                      <MainSectionBanner startJoyRide={startJoyRide} />
                    </div>
                    <div className="col-md-8 jn-section mt-1">
                      {!isGuest && (
                        <MyWall
                          fetchData={fetchMyWallData}
                          setIsLoading={setIsLoading}
                          fromPage={"home"}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

      {false && (userRole === "realtor" || userRole === "manager") ? (
        <RecommendationView fetchData={fetchMyWallData} />
      ) : (
        ""
      )}
    </>
  );
};

export default MainSection;
